/**
 * Contact page data
 * Centralized location for easy maintenance and updates
 */

export const contactMethods = [
  {
    id: 'phone',
    icon: '📞',
    title: 'Call Us',
    subtitle: 'Speak with our consultants',
    info: '+94 11 258 1181',
    link: 'tel:+94112581181',
    hours: 'Mon - Fri: 9.30 to 6.30 pm',
    action: 'Call Now'
  },
  {
    id: 'whatsapp',
    icon: '💬',
    title: 'WhatsApp',
    subtitle: 'Quick responses via chat',
    info: '+94 74 141 7993',
    link: 'https://wa.me/94741417993',
    hours: 'Mon - Fri: 9.30 to 6.30 pm',
    action: 'Chat on WhatsApp'
  },
  {
    id: 'email',
    icon: '✉️',
    title: 'Email Us',
    subtitle: 'For detailed inquiries',
    info: 'immi@ravanaindustries.com',
    link: 'mailto:immi@ravanaindustries.com',
    hours: 'Response within 24 hours',
    action: 'Send Email'
  }
];

export const additionalContactChannels = [
  {
    id: 'telegram',
    icon: '📱',
    title: 'Telegram',
    info: '@RavanaMigration',
    link: 'https://t.me/RavanaMigration',
    description: 'Quick messages'
  },
  {
    id: 'viber',
    icon: '📞',
    title: 'Viber',
    info: '+94 77 123 4567',
    link: 'viber://chat?number=94771234567',
    description: 'Free calls & messages'
  },
  {
    id: 'line',
    icon: '💬',
    title: 'LINE',
    info: '@RavanaMigration',
    link: 'https://line.me/RavanaMigration',
    description: 'Popular in Asia'
  },
  {
    id: 'wechat',
    icon: '💚',
    title: 'WeChat',
    info: 'ravana_migration',
    link: 'https://weixin.qq.com/ravana_migration',
    description: 'China & Asia'
  }
];

export const faqs = [
  {
    question: 'What are your working hours?',
    answer: 'We are open Monday - Friday, 9.30 to 6.30 pm (Sri Lanka time). Emergency support available 24/7 via WhatsApp for existing clients.'
  },
  {
    question: 'How quickly will you respond?',
    answer: 'We respond to emails within 24 hours. WhatsApp messages are typically answered within 2-4 hours during business hours.'
  },
  {
    question: 'Do you offer video consultations?',
    answer: 'Yes! Schedule a video consultation through our booking system. Initial consultations are free for qualifying applicants.'
  },
  {
    question: 'Can I visit your office without an appointment?',
    answer: 'While walk-ins are welcome, we recommend booking an appointment to ensure a consultant is available. Schedule online or call us.'
  }
];

export const socialMediaLinks = [
  {
    id: 'facebook',
    icon: '📘',
    name: 'Facebook',
    handle: '@RavanaMigration',
    link: 'https://facebook.com/RavanaMigration',
    followers: '15K+ Followers'
  },
  {
    id: 'instagram',
    icon: '📸',
    name: 'Instagram',
    handle: '@ravanamigration',
    link: 'https://instagram.com/ravanamigration',
    followers: '12K+ Followers'
  },
  {
    id: 'linkedin',
    icon: '💼',
    name: 'LinkedIn',
    handle: 'Ravana Migration',
    link: 'https://linkedin.com/company/ravana-migration',
    followers: '8K+ Followers'
  },
  {
    id: 'youtube',
    icon: '📺',
    name: 'YouTube',
    handle: 'Ravana Migration',
    link: 'https://youtube.com/@RavanaMigration',
    followers: '5K+ Subscribers'
  },
  {
    id: 'tiktok',
    icon: '🎵',
    name: 'TikTok',
    handle: '@ravanamigration',
    link: 'https://tiktok.com/@ravanamigration',
    followers: '20K+ Followers'
  },
  {
    id: 'twitter',
    icon: '🐦',
    name: 'Twitter/X',
    handle: '@RavanaMig',
    link: 'https://twitter.com/RavanaMig',
    followers: '3K+ Followers'
  }
];

export const offices = [
  {
    country: 'Sri Lanka',
    flag: '🇱🇰',
    type: 'Headquarters',
    address: 'No 10/30/1/1, Pamankada Lane',
    city: 'Wellawatta, Colombo 06',
    phone: '+94 11 258 1181',
    email: 'immi@ravanaindustries.com',
    hours: 'Mon - Fri: 9.30 to 6.30 pm'
  },
  {
    country: 'Germany',
    flag: '🇩🇪',
    type: 'European Operations',
    address: 'Wülfrather Str 17',
    city: '42105, Wupprtal, Germany',
    phone: 'On request',
    email: 'germany@ravanaindustries.com',
    hours: 'CET Business Hours'
  },
  {
    country: 'Canada',
    flag: '🇨🇦',
    type: 'North American Operations',
    address: '145 1/2 Church St unit 5',
    city: 'Toronto, ON M5B 1Y4, Canada',
    phone: '+1 437-830-2199',
    email: 'canada@ravanaindustries.com',
    hours: 'EST Business Hours'
  }
];

export const quickHelp = [
  {
    id: 'status',
    icon: '📝',
    title: 'Application Status',
    description: 'Track your application progress',
    link: 'https://erp.ravanaindustries.com/client-portal',
    linkText: 'Client Portal'
  },
  {
    id: 'faq',
    icon: '❓',
    title: 'FAQs',
    description: 'Common questions answered',
    link: '/pricing',
    linkText: 'View FAQs'
  },
  {
    id: 'resources',
    icon: '📚',
    title: 'Resources',
    description: 'Guides and blog articles',
    link: '/blog',
    linkText: 'Read Blog'
  },
  {
    id: 'booking',
    icon: '📅',
    title: 'Book Consultation',
    description: 'Schedule a meeting',
    link: '/wizard',
    linkText: 'Book Now'
  }
];

/**
 * Contact highlights
 */
export const contactHighlights = [
  {
    title: 'Response Time',
    value: '<24h',
    description: 'Email replies',
    icon: '⏱️'
  },
  {
    title: 'Offices',
    value: '3',
    description: 'Countries worldwide',
    icon: '🏢'
  },
  {
    title: 'Consultants',
    value: '10+',
    description: 'Immigration experts',
    icon: '👥'
  },
  {
    title: 'Support',
    value: '24/7',
    description: 'Chat available',
    icon: '💬'
  }
];
